import { ScrollView, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/features/global/components/logo/Logo';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { useAuth } from '~/auth/contexts/auth/Auth';

export interface LoginPageProps {}

export const LoginPage = ({}: LoginPageProps) => {
  const { t } = useTranslation('auth');
  const { handleLogin, isAuthenticating } = useAuth();

  return (
    <ScrollView
      testID="login-screen"
      className="flex-1 bg-bg"
      contentContainerClassName="flex-grow bg-bg"
    >
      <View className="flex-1 items-center justify-between px-8 py-12">
        {/* Content Section - Centered */}
        <View className="flex-1 items-center justify-center gap-10 md:gap-12 max-w-md w-full">
          {/* Brand Section */}
          <View className="items-center gap-6">
            <Logo size={80} className="md:w-24 md:h-24" />
            <Text className="font-sora-extrabold text-4xl text-text-primary tracking-tight lowercase">
              {t('brand.name')}
            </Text>
            <Text className="font-inter-regular text-base text-text-secondary text-center">
              {t('brand.tagline')}
            </Text>
          </View>

          {/* Message Section */}
          <View className="items-center gap-2 md:gap-3 w-full px-4">
            <Text
              testID="login-welcome-heading"
              className="font-sora-semibold text-xl text-text-primary text-center"
            >
              {t('welcome.heading')}
            </Text>
            <Text className="font-inter-regular text-sm text-text-secondary dark:text-text-muted leading-6 text-center w-full">
              {t('welcome.description')}
            </Text>
          </View>
        </View>

        {/* Bottom Section */}
        <View className="w-full max-w-md gap-4">
          <Button
            testID="login-authenticate-button"
            className="h-14 rounded-xl bg-accent"
            textClassName="text-base text-accent-text font-inter-semibold"
            onPress={handleLogin}
            loading={isAuthenticating}
          >
            {t('buttons.authenticate')}
          </Button>
          <Text className="font-inter-regular text-xs text-text-muted dark:text-text-secondary text-center leading-5">
            {t('footer.redirectNotice')}
          </Text>
        </View>
      </View>
    </ScrollView>
  );
};
